import { render } from "./Add.vue?vue&type=template&id=30d73498&scoped=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"

import "./Add.vue?vue&type=style&index=0&id=30d73498&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30d73498"

export default script